import React, { useState, useRef, useEffect } from "react";
import {
  Typography,
  Grid,
  TextField,
  Button,
  TablePagination,
  FormControl,
  IconButton,
  Autocomplete,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { Delete } from "@mui/icons-material";
import Card from "../../StyledComponents/Card/Card";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import CardText from "../../StyledComponents/Card/CardText";
import CardBody from "../../StyledComponents/Card/CardBody";

import { makeStyles } from "@material-ui/styles";
import moment from "moment";
import { CSVLink } from "react-csv";
import { formatDateTimeForBackend } from "../../Functions.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { ArrowBack } from "@mui/icons-material";

import FormControlLabel from "@material-ui/core/FormControlLabel";
// import FormControl from "@mui/material/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { uploadAdditioalDocumentFile } from "../Invoices/actions";
import VendorFinancingTable from "./Tables/VendorFinancing_Table";
import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style";
import { useNavigate } from "react-router-dom";
import VenderCode from "../Invoices/NewInvoice/Dropdowns/VenderCode";
import axios from "axios";
import getParameterByName from "../../Functions/functions";
import CustomSnackbar from "../../CustomSnackbar";
import VFDownload from "./Tables/VFDownload";
import { Error } from "@mui/icons-material";


const useStyles = makeStyles(dashboardStyle);

const VendorFinancing = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [archieve, setIsArchieve] = useState("false");
  // const [attachmentLoader, setAttchmentLoader] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [batchNo, setBatchNo] = useState([]);


  const [Batch, setBatch] = useState({
    invoice: "",
    comment: "",
  });

  const [formState, setFormState] = useState({
    batchFromDate: moment().subtract(3, "d").format("YYYY-MM-DD"),
    batchToDate: moment().format("YYYY-MM-DD"),
    RowsOfPage: 25,
    PageNo: 0
  });

  const getInvoices = async () => {
    setInvoiceLoading(true);
    const axios = require("axios");
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL
        }/api/VFTreasury/GetBatch?isArchive=${archieve == 'true' ? true : false}&fromDate=${formState.batchFromDate
        }&toDate=${formState.batchToDate}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    };
    axios
      .request(config)
      .then((response) => {
        setCount(response.data.length)
        setInvoices(response.data);
        setInvoiceLoading(false);
      })
      .catch((error) => {
        setInvoiceLoading(false);
      });
  };

  const archieveInvoices = async () => {
    setInvoiceLoading(true);
    if (batchNo.length === 0) {
      setErrorMessage("Please Select Batches")
      setInvoiceLoading(false)
    } else {
      let config = {
        method: archieve == 'false' ? "post" : "get",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/api/VFTreasury/${archieve == 'false' ? "ArchiveBatches" : "UnArchiveBatches"}?batchNos=${batchNo.toString()}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        },
      };

      axios
        .request(config)
        .then((response) => {
          // setInvoices([])
          getInvoices()
          setBatchNo([])
          setSuccessMessage(archieve == 'false' ? "Invoices Archieve Successfully " : "Invoices UnArchieve Successfully");
          setErrorMessage("")
          setInvoiceLoading(false);
        })
        .catch((error) => {

        });
    }
  };

  const additionalAttachmentRef = useRef(null);
  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };

  const handleChangePage = (event, newPage) => {
    setFormState((formState) => ({
      ...formState,
      PageNo: newPage,
    }));
  };

  const handleChangeRowsPerPage = (event) => {
    // setRowsPerPage(parseInt(event.target.value, 10));

    setFormState((formState) => ({
      ...formState,
      RowsOfPage: event.target.value,
    }));
    // setPage(0);
  };
  useEffect(() => {
    getInvoices();
  }, [formState, archieve]);

  return (
    <Card style={{ marginLeft: "20px" }}>
      <CardHeader color="primary" text>
        <CardText
          style={{
            padding: "1px 20px",
            backgroundColor: "#031C30",
            color: "white",
            height: "62px",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <h4>Vendor Financing Payments</h4>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{ float: "right", marginTop: "1.5%" }}
                onClick={() => navigate("/home")}
              >
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <form
        // onSubmit={(e) => submitHandler(e)}
        >
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <FormControl component="fieldset">
                {/* <FormLabel
                  required
                  // classes={{ asterisk: classes.asterisk }}
                  id="demo-row-radio-buttons-group-label"
                >
                  <b>Treasury</b>
                </FormLabel> */}
                <Typography>
                  <span className={classes.asterisk}>*</span>
                  Batches:
                </Typography>
                <RadioGroup
                  row
                  aria-label="gender"
                  name="gender1"
                  value={archieve}
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  onChange={(e) => {
                    setIsArchieve(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value={"false"}
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#C5C7CD",
                          "&.Mui-checked": {
                            color: "#0095DA",
                          },
                        }}
                      />
                    }
                    label="Active Batches"
                  />
                  <br />
                  <FormControlLabel
                    value={"true"}
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#C5C7CD",
                          "&.Mui-checked": {
                            color: "#0095DA",
                          },
                        }}
                      />
                    }
                    label="Archive Batches"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ paddingRight: "18px" }}
            >
              <Button
                variant="contained"
                color="secondary"
                size="small"
                style={{
                  marginLeft: "0px",
                  padding: "5px",
                  marginBottom: "10px",
                  marginTop: '-10px'
                }}
                onClick={archieveInvoices}
              >
                {archieve == 'false' ? "Archive " : "UnArchive"}
              </Button>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={-2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              lg={3}
              style={{ paddingRight: "18px" }}
            >
              <Typography>Batch From Date:</Typography>
              <input
                className={classes.inputField}
                type="date"
                max="9999-12-31"
                value={formState.batchFromDate}
                onChange={(newValue) => {
                  autocompleteChangeHandler(
                    "batchFromDate",
                    newValue.target.value,
                    formatDateTimeForBackend(newValue)
                  );
                }}
                style={{ height: 13 }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              lg={3}
              style={{ paddingRight: "18px" }}
            >
              <Typography>Batch To Date:</Typography>
              <input
                className={classes.inputField}
                type="date"
                max="9999-12-31"
                value={formState.batchToDate}
                onChange={(newValue) => {
                  autocompleteChangeHandler(
                    "batchToDate",
                    newValue.target.value,
                    formatDateTimeForBackend(newValue)
                  );
                }}
                style={{ height: 13 }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <VFDownload
              vendorList={invoices}
              getInvoices={getInvoices}

              loading={invoiceLoading}
              Batch={Batch}
              setBatch={setBatch}
              setSuccessMessage={setSuccessMessage}
              page={formState.PageNo}
              RowsPerPage={formState.RowsOfPage}
              batchNo={batchNo}
              setBatchNo={setBatchNo}
              errorMessage={errorMessage}

            />
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component="div"
              count={count}
              rowsPerPage={formState.RowsOfPage}
              page={parseInt(formState.PageNo)}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
        </form>
        {successMessage && (
          <CustomSnackbar
            open={successMessage !== ""}
            message={successMessage}
            handleClose={() => setSuccessMessage("")}
            variant="success"
          />
        )}
        {/*  {errorMessage && (
          <>
            {" "}
            <Grid container spacing={0}>
              <Grid item>
                <Error
                  titleAccess="Error"
                  className={classes.asterisk}
                  fontSize="small"
                />{" "}
              </Grid>
              <Grid item>
                <Typography className={classes.asterisk} ml={1}>
                  {" "}
                  {errorMessage}
                </Typography>
              </Grid>
            </Grid>
          </>
      )}*/}
      </CardBody>
    </Card>
  );
};

export default VendorFinancing;
